module.exports = {
	"No notifications found.": "No notifications found.",
	"Notifications": "Notificaciones",
	"See all notifications": "Ver todas las notificaciones",
	"Mark all as read": "Mark all as read"
};


//////////////////
// WEBPACK FOOTER
// ./~/@99designs/globalnav/translations/es.json
// module id = 901
// module chunks = 35